import {filterConditionFn} from "./filter_condition";

const filterConditionOut = filterConditionFn(false);

export default filterConditionOut;
